export default __webpack_public_path__ + "static/media/itemsPhoto.a490eeed.svg";